import * as api from '@/api/api'

// initial state
const state = {
	cartNumber: 0
}

// mutations
const mutations = {
	//设置购物车数量
	setCartNumber(state, value) {
		const num = Number(value)
		state.cartNumber = Number.isFinite(num) && num > 0 ? num : 0
	}
}

let cartCountPromise = null

const actions = {
	// 拉取购物车角标数量（接口返回纯数字）；并发调用复用同一请求
	fetchCartCount({ commit, rootState }) {
		if (!(rootState.auth && rootState.auth.isOnline)) {
			commit('setCartNumber', 0)
			cartCountPromise = null
			return Promise.resolve(0)
		}
		if (cartCountPromise) {
			return cartCountPromise
		}
		cartCountPromise = api.cartCount().then(res => {
			if (res && res.code == 200) {
				commit('setCartNumber', res.data)
				return res.data
			}
			return 0
		}).catch(() => 0).finally(() => {
			cartCountPromise = null
		})
		return cartCountPromise
	}
}

export default {
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js